import React from 'react';

export class Input extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value,
            errors: [],
        };

        this.handleChange = this.handleChange.bind(this);
        this.hasError = this.hasError.bind(this);
        this.getClassName = this.getClassName.bind(this);
    }

    handleChange(event) {
        if (! event) {
            return;
        }

        let value = event.target.type === 'number' ||
        (event.target.dataset.type && event.target.dataset.type === 'number') ?
            parseInt(event.target.value, 10) : event.target.value;
        this.setState({value});

        this.props.updateElement(this.props.name, value);
    }

    hasError() {
        return this.state.errors && this.state.errors.length > 0;
    }


    getClassName() {
        return this.hasError() ? "is-invalid form-control" : "form-control";
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value || prevProps.errors !== this.props.errors) {
            this.setState({
                value: this.props.value,
                errors: this.props.errors,
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <label>{this.props.label}{this.props.required ? '*' : ''}</label>
                <input className={this.getClassName()} type={this.props.type} value={this.state.value}
                       name={this.props.name} id={this.props.name} placeholder={this.props.placeholder}
                       onChange={this.handleChange} required={this.props.required} disabled={this.props.disabled}/>
                <div className="invalid-feedback">
                    <ul className="errors">
                        {this.hasError() ? this.state.errors.map((error, index) => {
                            return <li key={index + 1}>{error}</li>
                        }) : ''}
                    </ul>
                </div>
            </React.Fragment>
        );
    }
}